import { PolymerElement, html } from 'polymer';

/**
 * @demo demo/index.html
 * @customElement
 * @polymer
 * @appliesMixin HIP.BehaviorElement
 */
class CaseElement extends HIP.BehaviorElement(PolymerElement) {
  static get is() {
    return 'hi-case';
  }

  static get template() {
    return html`
      <style is="custom-style" include="hi-theme"></style>
      <style>
        :host {
          display: block;
        }
      </style>
      <div mixin="text-natural">
        <slot></slot>
      </div>
    `;
  }
}

HIP.factory.element(CaseElement);
